import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18.947",
  height: "20",
  fill: "none",
  viewBox: "3144 391 18.947 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3144 411v-14.737h6.315v-2.105l3.158-3.158 3.159 3.158v6.316h6.315V411zm2.105-2.105h2.106v-2.106h-2.106zm0-4.21h2.106v-2.106h-2.106zm0-4.211h2.106v-2.106h-2.106zm6.316 8.42h2.105v-2.105h-2.105zm0-4.21h2.105v-2.105h-2.105zm0-4.21h2.105v-2.106h-2.105zm0-4.21h2.105v-2.106h-2.105zm6.316 12.63h2.105v-2.105h-2.105zm0-4.21h2.105v-2.105h-2.105z",
      class: "fills",
      style: {"fill":"#1f7eff","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }